// 表格橫向捲動提示條（.sw-scroll-hint）——觸控裝置以自繪提示條取代原生
// 橫向捲動軸：初始常駐提示可橫滑，第一次滑動後改為「滑動時立即出現、
// 停止後淡出」。
// 涵蓋的捲動容器見 SCROLLER（與 plugins/custom/web/css/scroll-hint.css
// 成對，改這裡要同步改那邊）：Content Builder、CKEditor 與 Lexical
// （後兩者共用 .ck-content scope）。為何不用 ::-webkit-scrollbar 見該
// CSS 檔註解（偽元素做不出淡出）。
// 經 build-embed.mjs 以 esbuild 單檔 minify 出 dist/js/scroll-hint-<hash>.min.js，
// SharingWeb2 於 layouts/shop/web-layout.blade.php 以
// sharingnpm('scroll-hint.js') 全站載入。
// 不支援 :has 的舊瀏覽器整段不掛——CSS 端規則同樣不生效，回歸原生行為。
// 全體包在 IIFE 內：bare transform（不 wrap）下頂層 var 會變全域。
(function () {
  if (!CSS.supports("selector(:has(*))")) return;

  var SCROLLER = ".is-container div:has(> table), .ck-content .table";

  // thumb 寬度與位移依捲動幾何同步；不可捲時整條隱藏
  function refresh(el) {
    var thumb = el.swHintThumb;
    if (!thumb || !el.scrollWidth) return; // 隱藏容器 scrollWidth 為 0，避免 NaN
    var ratio = el.clientWidth / el.scrollWidth;
    thumb.parentNode.style.display = ratio >= 1 ? "none" : "";
    thumb.style.width = ratio * 100 + "%";
    thumb.style.transform = "translateX(" + el.scrollLeft * ratio + "px)";
  }

  function init() {
    document.querySelectorAll(SCROLLER).forEach(function (el) {
      if (el.swHintThumb) return;
      var hint = document.createElement("div");
      hint.className = "sw-scroll-hint";
      hint.appendChild((el.swHintThumb = document.createElement("i")));
      el.appendChild(hint);
      refresh(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // 轉向／視窗尺寸變化後重算 thumb 幾何
  window.addEventListener("resize", function () {
    document.querySelectorAll(SCROLLER).forEach(refresh);
  });

  document.addEventListener(
    "scroll",
    function (e) {
      var el = e.target;
      if (!(el instanceof Element) || !el.matches(SCROLLER)) return;
      refresh(el);
      el.classList.add("sw-scrolled", "sw-scrolling");
      clearTimeout(el.swScrollTimer);
      el.swScrollTimer = setTimeout(function () {
        el.classList.remove("sw-scrolling");
        // 300ms：Chromium Android overlay 捲軸停止後的 fade delay
      }, 300);
    },
    true,
  );
})();
